export default __webpack_public_path__ + "static/media/arrow.7005253c.svg";